import { render, staticRenderFns } from "./CompraCuentas.vue?vue&type=template&id=ed61c56c&"
import script from "./CompraCuentas.vue?vue&type=script&lang=js&"
export * from "./CompraCuentas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports